document.addEventListener('DOMContentLoaded', function () {
  const dropdownIcon = document.querySelector('.header-inline-dropdown-icon img');
  const dropdownMenu = document.querySelector('.header-inline-dropdown-menu');
  let isHovering = false;

  function showMenu() {
    dropdownMenu.style.display = 'block';
  }

  function hideMenu() {
    if (!isHovering) {
      dropdownMenu.style.display = 'none';
    }
  }

  dropdownIcon.addEventListener('mouseenter', function () {
    isHovering = true;
    showMenu();
  });

  dropdownMenu.addEventListener('mouseenter', function () {
    isHovering = true;
    showMenu();
  });

  dropdownIcon.addEventListener('mouseleave', function () {
    isHovering = false;
    setTimeout(hideMenu, 100); // small delay to allow mouse to enter menu
  });

  dropdownMenu.addEventListener('mouseleave', function () {
    isHovering = false;
    setTimeout(hideMenu, 100);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  let cards = document.querySelectorAll('.product-card-wrapper .card');
  cards.forEach(card => {
    let image = card.querySelector('.card__inner .card__media .media img');
    let variants = card.querySelectorAll('.card__content .card-information .card__product-variants .card__product-variant');
    variants.forEach(variant => {
       variant.addEventListener('click', function(){
         variants.forEach(variant => { variant.classList.remove('active');});
         this.classList.add('active');
         let varImage = this.getAttribute('data-image');
         image.setAttribute('srcset', varImage);
         image.setAttribute('src', varImage);
       });
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  let filterBtn = document.querySelector('.collection-buttons .filter-btn');
  let filterBtn2 = document.querySelector('.mobile-facets__wrapper .mobile-facets__open');
  if(filterBtn && filterBtn2){
    filterBtn.addEventListener('click', function(){
      filterBtn2.click();
    });
  }

  let cart = document.querySelector('#cart-icon-bubble-drawer');
  let drawer = document.querySelector('cart-drawer.drawer');
  cart.addEventListener('click', function(e){
    e.preventDefault();
    drawer.classList.add('active');
    document.body.classList.add('overflow-hidden');
  });
});

function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const itemCount = cart.item_count || 0;
      const cartCountElement = document.querySelector('.cart-icon-count');
      if (cartCountElement) {
        cartCountElement.textContent = `(${itemCount})`;
      }
    })
    .catch(error => {
      console.error('Cart fetch error:', error);
    });
}

// Har 5 second baad cart count update karen
setInterval(updateCartCount, 1000);

// Pehli dafa page load par bhi call karen
updateCartCount();

document.addEventListener('DOMContentLoaded', function () {
  function openPopup() {
    window.postscript.popups.open("1e6729a5-7fc2-4f80-aca6-6199729a52e9", {
      activePopupBehavior: 'ALWAYS_DISMISS',
      respectPopupStatus: false
    });
    console.log("Clicked");
  }
  let button = document.querySelector('.footer-top-image');
  let getAccessbtn = document.querySelector('.get-access-btn');
  console.log(button);
  button.addEventListener('click', openPopup);
  getAccessbtn.addEventListener('click', openPopup);

});

const waitForPopup = setInterval(() => {
  const popup = document.querySelector('#ps__widget_container');
  const getAccess = document.querySelector('.get-access-btn');

  if (popup && getAccess) {
    clearInterval(waitForPopup);

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-ps-popup-status') {
          const status = popup.getAttribute('data-ps-popup-status');
          if (status === 'open') {
            getAccess.classList.remove('full-left');
          } else if (status === 'close') {
            getAccess.classList.add('full-left');
          }
        }
      }
    });

    observer.observe(popup, {
      attributes: true,
      attributeFilter: ['data-ps-popup-status']
    });
  }
}, 300);


window.addEventListener('load', function(){
  let getAccess2 = document.querySelector('.get-access-btn');
  setTimeout(function(){
    getAccess2.style.left = '-60px';
  }, 3000);
});

/*
window.addEventListener('load', function () {
  const countdown = document.querySelector('.countdown-bar-item-countdown');
  const container = document.querySelector('.product__info-container');
  // if (!countdown || !container) return;

  const checkWrapper = setInterval(function () {
    const wrapper = document.querySelector('.csp-prod-wrapper-detailpage');
     if(countdown){
        if (!wrapper) {
          countdown.style.display = 'none';
        } else {
          countdown.style.display = 'block';
        }
     }
      // clearInterval(checkWrapper); // Stop checking once wrapper is found
    
  }, 300); // Check every 300ms
});
*/



// $(document).ready(function () {
//   function updateSelectedVariantText() {
//     var checkedInput = $('.product-form__input input:checked');
//     var value = checkedInput.val();
//     $('.selected-option-value').text(value);
//   }

//   // Initial value set on page load
//   updateSelectedVariantText();

//   // Use event delegation on a stable parent (like document or body)
//   $(document).on('change', '.product-form__input input', function () {
//     console.log("Checked");
//     setTimeout(updateSelectedVariantText, 1000); // reduced delay, but adjustable
//   });
// });

